import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d43f3d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-7" }, null, -1))
const _hoisted_4 = { class: "d-flex justify-content-between" }

import { computed, onMounted, reactive, ref } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { useI18n } from "vue-i18n";
import { ElNotification } from "element-plus";
import { PartyStatusTypes } from "@/core/types/PartyStatusTypes";
import CopyButton from "@/components/CopyButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserPersonalInfos',
  props: {
    userDetails: {},
    verificationDetails: {}
  },
  emits: ["update:userDetails"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useI18n();





const showSiteId = ref("");
const ruleFormRef = ref<FormInstance>();
const formData = ref<Record<string, any>>({});
const isLoading = ref(false);

const rules = reactive<FormRules>({
  email: [
    { required: true, message: "Please input email", trigger: "blur" },
    { type: "email", message: "Please input correct email", trigger: "blur" },
  ],
  firstName: [
    { required: true, message: "Please input first name", trigger: "blur" },
  ],
  lastName: [
    { required: true, message: "Please input last name", trigger: "blur" },
  ],
  nativeName: [
    { required: true, message: "Please input native name", trigger: "blur" },
  ],
  idIssuer: [
    { required: true, message: "Please input ID issuer", trigger: "blur" },
  ],
  phoneNumber: [
    { required: true, message: "Please input phone number", trigger: "blur" },
  ],
  birthday: [
    { required: true, message: "Please select birthday", trigger: "blur" },
  ],
  citizen: [
    { required: true, message: "Please input citizen", trigger: "blur" },
  ],
  address: [
    { required: true, message: "Please input address", trigger: "blur" },
  ],
  ccc: [{ required: true, message: "Please input CCC", trigger: "blur" }],
  idType: [
    { required: true, message: "Please select ID type", trigger: "blur" },
  ],
  idNumber: [
    { required: true, message: "Please input ID number", trigger: "blur" },
  ],
});

const accountDetails = ref({} as any);

const getUserInfos = async () => {
  try {
    isLoading.value = true;
    accountDetails.value = await UserService.getUserInfoByPartyId(
      partyId.value
    );
    console.log("accountDetails", accountDetails.value);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    formData.value["referCode"] = accountDetails.value.referCode;
    formData.value["nativeName"] = accountDetails.value.nativeName;
    formData.value["email"] = accountDetails.value.email;
    formData.value["citizen"] = accountDetails.value.citizen || "N/A";
    formData.value["address"] = accountDetails.value.address;
    formData.value["ccc"] = accountDetails.value.ccc;
    formData.value["phoneNumber"] = accountDetails.value.phoneNumber;
    formData.value["idNumber"] = accountDetails.value.idNumber;
    formData.value["idIssuer"] = accountDetails.value.idIssuer;

    isLoading.value = false;
  }
};
const submitForm = async () => {
  if (!ruleFormRef.value) return;
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        isLoading.value = true;
        const res = await TenantGlobalService.updateUserProfileInfo(
          partyId.value,
          formData.value
        );
        MsgPrompt.success("Update profile successfully");
        await resetForm(res);
        emits("update:userDetails", res);
      } catch (error) {
        MsgPrompt.error(error);
      } finally {
        isLoading.value = false;
      }
    } else {
      MsgPrompt.warning("Please fill in the required fields");
    }
  });
};

const updateStatus = async (newVal: any) => {
  try {
    isLoading.value = true;
    let form = {
      status: newVal,
    };
    await UserService.updateUserStatus(partyId.value, form);
    ElNotification({
      title: "Success",
      message: "Update status successfully",
      type: "success",
    });
  } catch (error) {
    ElNotification({
      title: "Error",
      message: "Update status failed",
      type: "error",
    });
  } finally {
    isLoading.value = false;
  }
};

const partyId = computed(
  () => props.verificationDetails?.partyId ?? props.userDetails?.partyId
);

const siteId = computed(() => props.verificationDetails?.siteId ?? 0);

const updateSiteID = async (_siteId: number) => {
  showSiteId.value = t("type.siteType." + _siteId);
};

const resetForm = async (_initialFormData?: any) => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
  var info = props.verificationDetails?.info ?? props.userDetails;
  if (props.verificationDetails) {
    info.phoneNumber = info.phone;
  }
  const initialForm = _initialFormData ?? info;
  formData.value = {
    ...initialForm,
    gender: parseInt(initialForm.gender),
    citizen: initialForm.citizen || "N/A",
  };
};

const options = Array.from({ length: 10000 }).map((_, idx) => ({
  value: `${idx + 1}`,
  label: `${idx + 1}`,
}));

onMounted(() => {
  resetForm(props.userDetails);

  showSiteId.value = t("type.siteType." + props.verificationDetails?.siteId);
  console.log("props.userDetails", props.userDetails);
  if (props.userDetails === undefined) {
    getUserInfos();
  } else {
    accountDetails.value = props.userDetails;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      "label-width": "auto",
      class: "demo-ruleForm",
      size: "default",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Last Login IP" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: accountDetails.value.lastLoginIp,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountDetails.value.lastLoginIp) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Registered IP" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: accountDetails.value.registeredIp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountDetails.value.registeredIp) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (formData.value.socialMedium)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.socialMedium, (type, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (type.account != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('fields.' + type.name),
                          prop: type.name,
                          style: {"width":"90%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: type.account,
                              "onUpdate:modelValue": ($event: any) => ((type.account) = $event),
                              disabled: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["label", "prop"]),
                        _createVNode(CopyButton, {
                          class: "ms-3",
                          content: type.account
                        }, null, 8, ["content"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, {
            label: "Site ID",
            prop: "siteID",
            style: {"width":"90%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: showSiteId.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showSiteId).value = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "ms-3",
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSiteModalRef?.show(partyId.value, siteId.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Update")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_form_item, { label: "Status" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: accountDetails.value.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((accountDetails.value.status) = $event)),
              "active-color": "#13ce66",
              "inactive-color": "#ff4949",
              "active-text": "Active",
              "inactive-text": "Inactive",
              "active-value": _unref(PartyStatusTypes).Active,
              "inactive-value": _unref(PartyStatusTypes).Closed,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (updateStatus(accountDetails.value.status)))
            }, null, 8, ["modelValue", "active-value", "inactive-value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: formData.value,
      rules: rules,
      "label-width": "auto",
      class: "demo-ruleForm",
      size: "default",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "Email",
          prop: "email"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Native Name",
          prop: "nativeName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.nativeName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.nativeName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "First Name",
          prop: "firstName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.firstName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.firstName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Last Name",
          prop: "lastName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.lastName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.lastName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Birthday",
          prop: "birthday"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formData.value.birthday,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.birthday) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Gender",
          prop: "gender"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formData.value.gender,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.gender) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Male")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Female")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Citizen",
          prop: "citizen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.citizen,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.citizen) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Address",
          prop: "address"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.address,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.address) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "CCC",
          prop: "ccc"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.ccc,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.ccc) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Phone",
          prop: "phoneNumber"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.phoneNumber,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.phoneNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "ID Type",
          prop: "idType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formData.value.idType,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.idType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.govId")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.driveLicense")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.passport")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "ID Number",
          prop: "idNumber"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.idNumber,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.idNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "ID Issuer",
          prop: "idIssuer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.idIssuer,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.idIssuer) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "ID Issued On",
          prop: "idIssuedOn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formData.value.idIssuedOn,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.idIssuedOn) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.expire_date'),
          prop: "idExpireOn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formData.value.idExpireOn,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.idExpireOn) = $event)),
              type: "date",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          "label-width": 100,
          label: "Refer Code",
          prop: "Refer Code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.referCode,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.referCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitForm,
              loading: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              disabled: isLoading.value,
              onClick: _cache[22] || (_cache[22] = ($event: any) => (resetForm('form')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})